// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3rJI9","notes":"Notes_notes__ZMg_o","note":"Notes_note__a4B4i","markdown":"Notes_markdown__1NmiS"};